"use client"

import { myLinks, permissionsMenu } from "@/lib/routes/myLinks";
import {
    categoriesNav,
    customersNav,
    dashboardNav,
    marketingNav,
    purchasesNav,
    supportNav,
    systemEditionNav
} from "@/lib/routes/nav";
import { Link } from "@/theme/ui";
import {
    CategoriesIcon,
    MarketingIcon,
    SupportIcon,
    PurchasesIcon,
    CustomersIcon,
    DashboardIcon,
    UserRoles, SystemEditionIcon
} from "@/theme/assets/icons";

const general_group = [
    ...dashboardNav,
    ...customersNav,
    ...purchasesNav,
    ...supportNav
]

const settings_group = [
    ...marketingNav,
    ...categoriesNav,
    ...systemEditionNav
]

export const menuItems = [
    getItem({
        label: 'GENERAL', key: 'general_group', type: 'group', permissions: permissionsMenu(general_group), children: [
            getItem({ ...myLinks.getLink('dashboard.index'), icon: <DashboardIcon />, iconActive: <DashboardIcon />  }),
            getItem({ ...myLinks.getLink('customers.index'), icon: <CustomersIcon />, iconActive: <CustomersIcon />  }),
            getItem({ ...myLinks.getLink('purchases.index'), icon: <PurchasesIcon />, iconActive: <PurchasesIcon />  }),
            getItem({ ...myLinks.getLink('support.index'), icon: <SupportIcon />, iconActive: <SupportIcon />  }),
        ]
    }),
    getItem({
        label: 'SETTINGS', key: 'settings_group', type: 'group', permissions: permissionsMenu(settings_group), children: [
            getItem({ ...myLinks.getLink('categories.index'), icon: <CategoriesIcon />, iconActive: <CategoriesIcon /> }),
            // getItem({
            //     label: 'Categories',
            //     icons: <CategoriesIcon />,
            //     iconActive: <CategoriesIcon />,
            //     key: 'categories_group',
            //     type: 'sub',
            //     children: [
            //         getItem({ ...myLinks.getLink('categories.index') }),
            //         // getItem({ ...myLinks.getLink('subcategories.one.index') }),
            //         // getItem({ ...myLinks.getLink('subcategories.two.index') }),
            //     ],
            // }),
            getItem({
                label: 'System edition',
                icons: <SystemEditionIcon />,
                iconActive: <SystemEditionIcon />,
                key: 'system_group',
                type: 'sub',
                children: [
                    getItem({ ...myLinks.getLink('landing.index') }),
                ],
            }),
            getItem({ ...myLinks.getLink('marketing.index'), icon: <MarketingIcon />, iconActive: <MarketingIcon />  }),
            getItem({ ...myLinks.getLink('roles.index'), icon: <UserRoles />, iconActive: <UserRoles />  }),
        ]
    }),
]

function getItem({ label, key, icon, iconActive, children, type, url, permissions = [] }) {

    const iconWrapper = (icon, className = '') => {
        return (
            <div className={`${className}`}>
                {icon}
            </div>
        )
    }

    const getIcon = (icon, iconActive) => {
        if (iconActive && icon) {
            return (
                <>
                    <div
                        className={'ant-menu-item-icons'}
                        style={{maxWidth: '25px'}}
                    >
                        {(icon) && iconWrapper(icon, 'menu_icon_default menu_icon')}
                        {(iconActive) && iconWrapper(iconActive, 'menu_icon_active menu_icon')}
                    </div>
                </>
            )
        }

        if (iconActive) {
            return iconWrapper(iconActive, 'menu_icon')
        }

        if (icon) {
            return iconWrapper(icon, 'menu_icon')
        }

        return null
    }

    const resp = {
        key,
        icon: getIcon(icon, iconActive),
        children,
        label: url
            ? (
                <>
                    <Link href={url}>
                        {label}
                    </Link>
                </>
            )
            : label
        ,
        type,
        permissions,
        theme: 'light',
    }

    if (children) {
        resp.popupClassName = 'hidden_popup_menu'
    }

    return resp;
}
